module.exports = __webpack_public_path__ + "static/media/13.1d7c3bcb.png";